var map = {
	"./0/Charles Johnson.jpg": "8d27",
	"./0/Cladius Lee - KKK Section Photos/CladiusLeeKKKBugle.png": "572f",
	"./0/Cladius Lee - KKK Section Photos/KKKClubPageBugle1896.png": "7e1e",
	"./0/Cladius Lee - KKK Section Photos/PittsylvaniaClubBugle1896.png": "911d",
	"./0/ClayToHoge.gif": "8bdd",
	"./0/Copy of charles yates, 1958.jpg": "0f53",
	"./0/Hoge House Section Photos/Cherry in Hoge room.jpg": "a542",
	"./0/Hoge House Section Photos/Cherry studying.jpg": "e97a",
	"./0/Hoge House Section Photos/Essex Finney with Mr. and Mrs. Hoge, 1959 .jpg": "22e8",
	"./0/Hoge House Section Photos/Floyd Wilson, Irving Peddrew and Charles Yates .jpg": "9ee2",
	"./0/Hoge House Section Photos/LINDSAY CHERRY, IN HOGE HOUSE, 1956 .jpg": "a221",
	"./0/Hoge House Section Photos/Lindsay Cherry at Hoge House, 1954.jpg": "f5ed",
	"./0/Walk from house to hall section/Lindsay Cherry walking to campus, 1955.jpg": "66bf",
	"./0/Walk from house to hall section/Lindsay Cherry, 1956.jpg": "3eb7",
	"./0/narration/HogeHall.mp3": "d079",
	"./0/narration/HogeHall1.mp3": "fdb8",
	"./0/narration/HogeHall2.mp3": "5f4e",
	"./0/narration/HogeHall3.mp3": "228e",
	"./0/narration/charles.mp3": "db6d",
	"./1/Freddie Hairston/Freddie Hairston, 1968 (1).jpg": "ae7e",
	"./1/Freddie Hairston/Screen Shot 2020-10-28 at 9.53.39 AM.png": "5c8b",
	"./1/Freddie Hairston/freddie at hillcrest dorm party.png": "37c9",
	"./1/Freddie Hairston/freddie dress 1.png": "c50d",
	"./1/Freddie Hairston/freddie dress 2.png": "a1a4",
	"./1/Freddie Hairston/fredi papermate.gif": "1756",
	"./1/Jackie Butler Blackwell/Jacki Butler 1969 (1).jpg": "8573",
	"./1/Jackie Butler Blackwell/Jackie Butler Premed club, 1969 (1).jpg": "a53c",
	"./1/Linda Adams/1967 unveristy chior.png": "ca4b",
	"./1/Linda Adams/Linda Adams, 1968 (1).jpg": "ddf2",
	"./1/Linda Adams/Screen Shot 2020-10-28 at 10.05.17 AM.png": "569c",
	"./1/Linda Adams/adams first graduate letter.jpg": "9c46",
	"./1/Linda Edmonds Turner/LA VERNE HIGGINS, LINDA EDMONDS TURNER, AND MARGUERITE LAURETTE (HARPER) _ CHICK_ SCOTT AT THE BLACK ALUMNI REUNION AWARDS CEREMONY, 2016 (1).jpg": "eb65",
	"./1/Linda Edmonds Turner/Linda Edmond Turner in phi upsilon omicron, the choir (1).png": "0113",
	"./1/Linda Edmonds Turner/Linda Edmonds Turner (1).png": "abbd",
	"./1/Linda Edmonds Turner/Linda Edmonds Turner 1970.jpg": "fe85",
	"./1/Linda Edmonds Turner/Linda Turner Formal.jpeg": "21b6",
	"./1/Linda Edmonds Turner/Linda edmonds in university home ec club.png": "0b8d",
	"./1/Marguerite Harper Scott/Dixie article 1.jpg": "151d",
	"./1/Marguerite Harper Scott/MARGUERITE HARPER, MEMBER OF STANDING SENATE COMMITTEE, CREDENTIALS AND ELECTIONS, THE 1969 BUGLE (2).jpg": "4474",
	"./1/Marguerite Harper Scott/Marguerite Harper Scott (1).png": "159a",
	"./1/Opening Hillcrest Womens History Section/Copy of MILDRED TATE, PROFESSOR OF HOME ECONOMICS FROM 1937 THROUGH 1960.jpg": "89e5",
	"./1/Opening Hillcrest Womens History Section/Dr. Laura Jane Harper, first dean of women.jpg": "b51b",
	"./1/Opening Hillcrest Womens History Section/Dr. Mildred Tate talking with female students, 1955.jpg": "8360",
	"./1/Opening Hillcrest Womens History Section/Hillcrest Hall, 1941.jpg": "7871",
	"./1/Opening Hillcrest Womens History Section/Hillcrest Hall, the Skirt Barn.jpeg": "1366",
	"./1/Opening Hillcrest Womens History Section/MILDRED TATE LETTER, 1940.jpg": "b480",
	"./1/Opening Hillcrest Womens History Section/Skirt Barn, 1950.jpg": "fe09",
	"./1/Opening Hillcrest Womens History Section/Students in home ec kitchen, 1950s-60s.jpg": "71b1",
	"./1/Photos of first black women/Chiquita Hudson, Marguerite Harper and Linda Adams, 1966 .jpg": "7ad3",
	"./1/Photos of first black women/Freddie Hairston, 1968.jpg": "510e",
	"./1/Photos of first black women/Jackie Butler 1969.jpg": "643f",
	"./1/Photos of first black women/Jackie Butler Premed club, 1969.jpg": "a3e9",
	"./1/Photos of first black women/LA VERNE HIGGINS, LINDA EDMONDS TURNER, AND MARGUERITE LAURETTE (HARPER) _ CHICK_ SCOTT AT THE BLACK ALUMNI REUNION AWARDS CEREMONY, 2016.jpg": "4089",
	"./1/Photos of first black women/La Verne Hairston, Linda Adams, and Chiquita Hudson - 1966.jpg": "066d",
	"./1/Photos of first black women/Linda Adams, 1968.jpg": "e0be",
	"./1/Photos of first black women/Linda Edmonds Turner in phi upsilon omicron, the choir.png": "a5af",
	"./1/Photos of first black women/Linda Edmonds Turner.png": "4c2b",
	"./1/Photos of first black women/MARGUERITE HARPER, MEMBER OF STANDING SENATE COMMITTEE, CREDENTIALS AND ELECTIONS, THE 1969 BUGLE.jpg": "d3c7",
	"./1/Photos of first black women/Marguerite Harper Scott.png": "ddd0",
	"./1/narration/FreddieHairstonQuote.mp3": "eeec",
	"./1/narration/Hillcrest Hall 1.mp3": "1c13",
	"./1/narration/Hillcrest Hall 2.mp3": "72a2",
	"./1/narration/Hillcrest Hall 3.mp3": "007c",
	"./1/narration/JackieButlerBlackwellQuote.mp3": "dab4",
	"./1/narration/LindaEdmondsTurnerQuote.mp3": "61e5",
	"./1/narration/MargueriteHarperScottQuote.mp3": "708f",
	"./2/Charlie Yates Section/Charles Yates at Graduation, 1958  (1).jpg": "b444",
	"./2/Charlie Yates Section/charles yates old.jpg": "b550",
	"./2/Charlie Yates Section/charles yates, 1958 (1).jpg": "53f1",
	"./2/Essex Finney Section/Essex Finney as Cadet, 1959.jpg": "647e",
	"./2/Essex Finney Section/Essex Finney with Mr. and Mrs. Hoge, 1959 .jpg": "ef2a",
	"./2/Floyd Wilson Section/Floyd Wilson, Irving Peddrew and Charles Yates .jpg": "1f23",
	"./2/Irving Peddrew III Section/Copy of Peddrew Bowling.jpg": "4b10",
	"./2/Irving Peddrew III Section/Peddrew at commencement.jpg": "9e68",
	"./2/Irving Peddrew III Section/VT admites first Negro (1).jpg": "b454",
	"./2/Irving Peddrew III Section/irving peddrew, 1953.jpg": "d799",
	"./2/James Whitehurst Section/James Whitehurst on Board of Visitors, 1972 (1).jpg": "1c3d",
	"./2/Lindsay Cherry Section/CHARLES YATES, ESSEX FINNEY, LINDSAY CHERRY AND MATTHEW WINSTON SR. IN 1999.jpg": "915f",
	"./2/Lindsay Cherry Section/Cherry in company A.jpg": "cd90",
	"./2/Lindsay Cherry Section/Lindsay Cherry 1957.jpg": "bf73",
	"./2/Matthew Winston Sr. Section/Old Winston and boys.jpg": "116f",
	"./2/Matthew Winston Sr. Section/matthew winston sr, 1959.jpg": "ff61",
	"./2/Opening photos/Charles Yates at Graduation, 1958 .jpg": "7c5f",
	"./2/Opening photos/James Whitehurst on Board of Visitors, 1972.jpg": "9cfc",
	"./2/Opening photos/VT admites first Negro.jpg": "e4df",
	"./2/Opening photos/charles yates, 1958.jpg": "2ae6",
	"./2/Opening photos/confederate states.jpg": "f0a3",
	"./2/narration/charles.mp3": "7e6a",
	"./2/narration/finney.mp3": "9fea",
	"./2/narration/irving.mp3": "2dd3",
	"./2/narration/peddrew.mp3": "4925",
	"./2/narration/students.mp3": "32a9",
	"./2/narration/trailblazers.mp3": "f56d",
	"./2/narration/winston.mp3": "387fe",
	"./2/narration/yates.mp3": "7903",
	"./3/Cadets.png": "c51a",
	"./3/James Whitehurst on Board of Visitors, 1972.jpg": "d4fb",
	"./3/Lane 1890.jpg": "8ebd",
	"./3/Lane Hall 2.png": "3d40",
	"./3/Lane Hall 3.jpg": "64b4",
	"./3/Lane Hall.png": "2c96",
	"./3/narration/Lane Hall Section 1.mp3": "0b35",
	"./3/narration/Lane Hall Section 2.mp3": "b194",
	"./4/150OshagtoJackson.gif": "43bd",
	"./4/Corps Minstrel 1922.png": "a1af",
	"./4/Football Minstrel Show.png": "f205",
	"./4/Groove Phi Groove House Section/Dick Gregory with HRC.png": "5626",
	"./4/Groove Phi Groove House Section/First GPG.png": "9fae",
	"./4/Groove Phi Groove House Section/GPG Sweethearts.png": "8c1d",
	"./4/Groove Phi Groove House Section/GPG members on drillfield.png": "e545",
	"./4/Groove Phi Groove House Section/GPG photo 1.png": "0a6e",
	"./4/Groove Phi Groove House Section/GPG photo 2.png": "8b63",
	"./4/Groove Phi Groove House Section/GPG photo 3.png": "45d2",
	"./4/Groove Phi Groove House Section/GPG photo 4.png": "d80d",
	"./4/Groove Phi Groove House Section/Groove Phi Groove Reunion 2000.jpg": "231b",
	"./4/Groove Phi Groove House Section/Muhammad Ali at GPG house.png": "0815",
	"./4/Larry Beale.jpg": "763d",
	"./4/james watkins, 1977.jpg": "8704",
	"./4/narration/O’Shaughnessy- GPG House Section 1.mp3": "a9ed",
	"./4/narration/O’Shaughnessy- GPG House Section 2.mp3": "10ee",
	"./4/narration/O’Shaughnessy- GPG House Section 3.mp3": "b8c6",
	"./5/Alpha Kappa Alpha Section/AKA 1975.png": "9423",
	"./5/Alpha Kappa Alpha Section/AKA 1976.png": "5fc0",
	"./5/Alpha Kappa Alpha Section/AKA 1977.png": "750a",
	"./5/Alpha Kappa Alpha Section/AKA 1981.png": "6338",
	"./5/Alpha Kappa Alpha Section/AKA 1982.png": "5711",
	"./5/Alpha Kappa Alpha Section/AKA 1995.png": "c11b",
	"./5/Alpha Kappa Alpha Section/AKA 2001.jpg": "dcb3",
	"./5/Alpha Kappa Alpha Section/AKA at MissEgyp 1997.png": "45a7",
	"./5/Alpha Phi Alpha section/ALPHA PHI ALPHA, JEFFERSON NATIONAL PARK, 1975.jpg": "b657",
	"./5/Alpha Phi Alpha section/APA 1974.png": "c054",
	"./5/Alpha Phi Alpha section/APA 1975.png": "0247",
	"./5/Alpha Phi Alpha section/APA 1978.png": "b742",
	"./5/Alpha Phi Alpha section/APA 1999.png": "ca42e",
	"./5/Alpha Phi Alpha section/APA at IFC 1976.png": "c861",
	"./5/Alpha Phi Alpha section/APA stepping 1980 2.png": "7ef7",
	"./5/Alpha Phi Alpha section/Stepping APA 1980.jpg": "8d71",
	"./5/D2 Opening Photos/ALPHA PHI ALPHA, JEFFERSON NATIONAL PARK, 1975.jpg": "2e4b",
	"./5/D2 Opening Photos/BOCGreek1990.jpg": "6137",
	"./5/Delta Sigma Theta Section/DST 1991.jpg": "2bdf",
	"./5/Delta Sigma Theta Section/DST 2001 member.png": "b3a8",
	"./5/Delta Sigma Theta Section/DST 2004.png": "1466",
	"./5/Delta Sigma Theta Section/DST member 2003.png": "110b",
	"./5/Delta Sigma Theta Section/DST1986.jpg": "8ebc",
	"./5/Delta Sigma Theta Section/dst stepping 2001.png": "6e90",
	"./5/Kappa Alpha Psi Section/Kappa Alpha Psi 1995.jpg": "e035",
	"./5/Omega Psi Phi Section/OPP 1982.jpg": "eacc",
	"./5/Omega Psi Phi Section/OPP sisters stepping 1989.png": "6eb1",
	"./5/Omega Psi Phi Section/OPP stepping 1989.jpg": "c514",
	"./5/Omega Psi Phi Section/OPP1986.png": "aba8",
	"./5/Omega Psi Phi Section/OPP2003.jpg": "f7d5",
	"./5/Phi Beta Sigma Section/Phi beta sigma 1994.jpg": "1ba5",
	"./5/Phi Beta Sigma Section/PhiBetaSig1995.jpg": "7469",
	"./5/Phi Beta Sigma Section/phibetasigma2003.jpg": "d8de",
	"./5/Sigma Gamma Rho Section/SigmaGammaRho1986.jpg": "aab7",
	"./5/Stepping-Overton Johnson Section/APA stepping 1980.png": "f567",
	"./5/Stepping-Overton Johnson Section/OPP sisters stepping 1989.png": "5467",
	"./5/Stepping-Overton Johnson Section/OPP stepping 1989.jpg": "4f02",
	"./5/Stepping-Overton Johnson Section/Overton Johnson.jpg": "46ed",
	"./5/Stepping-Overton Johnson Section/Stepping APA 1980.jpg": "3eba",
	"./5/Stepping-Overton Johnson Section/Stepping APA, 1984.png": "c204",
	"./5/Stepping-Overton Johnson Section/stepshow1995.jpg": "535b",
	"./5/Zeta Phi Beta Section/ZetaPhiBeta1994.jpg": "10b2",
	"./5/Zeta Phi Beta Section/ZetaPhiBeta1995.jpg": "8666",
	"./5/narration/D2 Plaza 1 and 2.mp3": "d9a4",
	"./5/narration/D2 Plaza 10.mp3": "0666",
	"./5/narration/D2 Plaza 11.mp3": "b7ff",
	"./5/narration/D2 Plaza 12.mp3": "f470",
	"./5/narration/D2 Plaza 3.mp3": "886b",
	"./5/narration/D2 Plaza 4.mp3": "d8b6",
	"./5/narration/D2 Plaza 5.mp3": "ca1c",
	"./5/narration/D2 Plaza 6.mp3": "f921",
	"./5/narration/D2 Plaza 7.mp3": "6e73",
	"./5/narration/D2 Plaza 8.mp3": "1b61",
	"./5/narration/D2 Plaza 9.mp3": "23e8",
	"./6/Board of Visitors Protest Section/BOV protest opening statement.png": "e792",
	"./6/Board of Visitors Protest Section/affirmative action burrss.png": "60e0",
	"./6/Board of Visitors Protest Section/death blow.png": "03ad",
	"./6/Board of Visitors Protest Section/drillfield BOV protest.png": "6023",
	"./6/Board of Visitors Protest Section/faculty slam BOV action.png": "d503",
	"./6/Intro/BurrussHall1939.jpeg": "dc7a",
	"./6/MLK Flagpole Section/MLK flagpole image 1.png": "b6ea",
	"./6/MLK Flagpole Section/mlk flagpole image 2.jpg": "32bc",
	"./6/MLK Flagpole Section/mlk linda page 1.jpg": "4862",
	"./6/MLK Flagpole Section/mlk linda pg 2.jpg": "cc0b",
	"./6/MLK Flagpole Section/mlk newspaper article.png": "9bf4",
	"./6/Minstrel Performances Section/1964 bugle- Minstrels _continuing in true southern tradition_.png": "a409",
	"./6/Minstrel Performances Section/Corps Minstrel men 1922.png": "e2e1",
	"./6/Minstrel Performances Section/Minstrel show 1964 bugle 1.jpg": "a24b",
	"./6/Minstrel Performances Section/Minstrel show 1964 bugle 2.png": "7d22",
	"./6/Minstrel Performances Section/march 5 1965 minstrel article in collegiate times.jpg": "8f09",
	"./6/narration/Burruss Hall Part 1.mp3": "f830",
	"./6/narration/Burruss Hall Part 2.mp3": "cb5e",
	"./6/narration/Burruss Hall Part 3.mp3": "7a28",
	"./6/narration/Burruss Hall Part 4.mp3": "0137",
	"./6/narration/Burruss Hall.mp3": "d12f",
	"./7/Brian K Roberts.png": "575f",
	"./7/Daniel Levi.png": "35d5",
	"./7/Lisa ellison.png": "a307",
	"./7/Matthew Winston Sr. and Jr. in front of legacy mural.jpg": "bf36",
	"./7/Student Testimonies opening photo.jpg": "aa7d",
	"./7/kimberly williams.jpg": "b19e",
	"./7/narration/brian.mp3": "a7a7",
	"./7/narration/creation.mp3": "66b5",
	"./7/narration/home.mp3": "6766"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "115f";